import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = ['password']

    showPassword() {
        this.passwordTarget.classList.toggle('visible')
    }
}
